import ReportPreviewPageSections from 'app/modules/analytics/modules/reports/components/reportPreview/ReportPreviewPageSections';
import type { ReportProfilePreviewSectionsProps } from '../types/ReportProfilePreviewSectionsProps';

const DefaultReportPreviewSections = (
  props: ReportProfilePreviewSectionsProps,
) => (
  <ReportPreviewPageSections
    page={props.page}
    performancePages={props.performancePages}
    performanceOverview={props.performanceOverview}
    isPerformanceLoading={props.isPerformanceLoading}
    getPerformanceMetricValue={props.getPerformanceMetricValue}
    performanceEmptyMessage={props.performanceEmptyMessage}
    isContentLoading={props.isContentLoading}
    getContentMetricValue={props.getContentMetricValue}
    isContentPostsLoading={props.isContentPostsLoading}
    performanceNote={props.performanceNote}
    contentNote={props.contentNote}
    showPerformanceNote={props.showPerformanceNote}
    showContentNote={props.showContentNote}
  />
);

export default DefaultReportPreviewSections;
